import { Paper } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  getPreguntasActividad,
  postActividadForm,
} from "../../../../redux/actions/obra";
import CircularLoading from "../../../commons/loading/CircularLoading";
import PlanillaTable from "../../../commons/planillas/PlanillaTable";
import FechaPresentacionObra from "../commons/FechaPresentacionObra";
import { validateActividadADesarrollar } from "../validation/formValidation";

const ActividadADesarrollarContainer = ({ nextForm }) => {
  const dispatch = useDispatch();

  const preguntas = useSelector((state) => state.obra.actividad);
  const actividadPost = useSelector(
    (state) => state.obra.postNuevaObra.actividad.preguntas
  );

  const [contador, setContador] = useState(0);
  const [grupoActual, setGrupoActual] = useState(null);

  const totalGrupos = preguntas.data.length;
  const loading = !grupoActual || preguntas.loading;
  const tituloGrupo = grupoActual?.nombre;

  useEffect(() => {
    dispatch(getPreguntasActividad());
  }, []);

  useEffect(() => {
    if (preguntas.data?.length) {
      setGrupoActual({
        ...preguntas.data[contador],
        itemsFormularioArt:
          actividadPost[contador]?.itemsFormularioArt ||
          preguntas.data[contador].itemsFormularioArt,
      });
    }
  }, [preguntas.data, contador]);

  const handleSubmit = (values) => {
    if (contador >= totalGrupos - 1) {
      const todosLosGrupos = [
        ...actividadPost.slice(0, contador),
        {
          itemsFormularioArt: values.opciones,
          idGrupoItemFormularioArt: grupoActual.idGrupoItemFormularioArt,
          nombre: grupoActual.nombre,
          secuencia: grupoActual.secuencia,
        }
      ];

      const todasLasOpciones = todosLosGrupos
        .flatMap(grupo => grupo.itemsFormularioArt);

      const hayErrorEnSeleccion = todasLasOpciones.some(item =>
        item.resultado === "1" &&
        item.opciones?.length > 0 &&
        !item.seleccionOpcion
      );

      if (hayErrorEnSeleccion) {
        toast.error("Debe seleccionar una opción de construcción para cada actividad marcada como 'Sí'");
        return;
      }
    }

    dispatch(
      postActividadForm({
        itemsFormularioArt: values.opciones,
        idGrupoItemFormularioArt: grupoActual.idGrupoItemFormularioArt,
        nombre: grupoActual.nombre,
        secuencia: grupoActual.secuencia,
      })
    );
    if (contador >= totalGrupos - 1) {
      nextForm("Demolición");
    } else {
      setContador((prev) => prev + 1);
    }
  };

  const handleGoBack = (values) => {
    dispatch(
      postActividadForm({
        itemsFormularioArt: values.opciones,
        idGrupoItemFormularioArt: grupoActual.idGrupoItemFormularioArt,
        nombre: grupoActual.nombre,
        secuencia: grupoActual.secuencia,
      })
    );
    setContador((prev) => prev - 1);
  };

  const columns = useMemo(() => [
    { id: `pregunta`, label: "" },
    { id: "si", label: "Sí" },
    { id: "no", label: "No" },
    { id: "seleccionOpcion", label: "" },
  ], [])

  return (
    <>
      <FechaPresentacionObra />
      <Paper>
        {!loading ? (
          <PlanillaTable
            data={grupoActual.itemsFormularioArt}
            tituloGrupo={tituloGrupo}
            totalGrupos={totalGrupos}
            contador={contador}
            handleSubmit={handleSubmit}
            handleGoBack={handleGoBack}
            construccion={true}
            capitalizeTitle={false}
            validationSchema={validateActividadADesarrollar}
            columns={[
              { id: `pregunta`, label: "" },
              { id: "si", label: "Sí" },
              { id: "no", label: "No" },
              { id: "seleccionOpcion", label: "" },
            ]}
          />
        ) : (
          <div>
            <CircularLoading />
          </div>
        )}
      </Paper>
    </>
  );
};

export default ActividadADesarrollarContainer;
